module.exports = __webpack_public_path__ + "images/emoji/newspaper.fa6e258e8b9ea394d95b.png";